import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import classnames from 'classnames';

export default class MenuBFW extends React.Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    const parentCloseFuncCall = this.props.parentCloseFuncCall;
  }

  handleCategoryLinkClick = (e) => {
    this.parentCloseFuncCall();
  }

  bfwMenuObj = [
    {
      name: 'Women-Owned Business Directory',
      url: '/buy-from-women-owned-businesses',
      slug: 'buy-from-women-owned-businesses',
      isExternalUrl: false
    },
    /** Tmp offline{
      name: 'Members only discounts and deals',
      url: '/buy-from-women-offers',
      slug: 'buy-from-women-offers',
      isExternalUrl: false
    },**/
  ];

  handleLinkClick = (e) => {
    this.parentCloseFuncCall();
  }

  render() {
    const { bfwMenuState, browser } = this.props;

    let linkPath = '';
    let iconPath = '';
    let menuLinks = this.bfwMenuObj.map(menuLink => {
      linkPath = menuLink.url;
      if (menuLink.isExternalUrl) {
        return <li key={menuLink.slug}>
          <div className="mainMenu-subNavLinkWrapper">
            <div className="mainMenu-subNavLink"><a target="_blank" href={linkPath} onClick={this.handleLinkClick}>{menuLink.name}</a></div>
          </div>
        </li>
      } else {
        return <li key={menuLink.slug}>
          <div className="mainMenu-subNavLinkWrapper">
            <div className="mainMenu-subNavLink"><Link to={linkPath} onClick={this.handleLinkClick}>{menuLink.name}</Link></div>
          </div>
        </li>
      }

    });

    let menuLinksWrapper = <ul className="mainMenu-subNavList subNavApply">{menuLinks}</ul>;

    let bfwMenu = '';


    if (bfwMenuState && !browser.greaterThan.desktop) {
      bfwMenu = <div className="mainMenuDropDownInnerWrapper">
        <div className="mainMenuDropDown">{menuLinksWrapper}</div>
      </div>
    } else if (browser.greaterThan.desktop) {
      bfwMenu = <div className="mainMenuDropDownInnerWrapper">
        <div className="mainMenu-subNavPointer">
          <img src="/images/subnav/subnav_pointer_bkgd.png" />
        </div>
        <div className="mainMenuDropDown">{menuLinksWrapper}</div>
      </div>
    }


    return(
      <div>
        {bfwMenu}
      </div>
    );
  }
}

MenuBFW.propTypes = {
  bfwMenuState: PropTypes.bool.isRequired,
  parentCloseFuncCall: PropTypes.func.isRequired,
  browser: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/header/MenuBFW.jsx